import {BackendSearchResult, SearchResult} from '../object-search.model';
import {ObjectDetailsMapper} from '@frontmania/object-master-data';

export class SearchResultMapper {

  static map(backendResult: BackendSearchResult): SearchResult {
    return new SearchResult(ObjectDetailsMapper.mapMany(backendResult.elements), backendResult.totalElements);
  }
}
